import { createAsyncThunk } from '@reduxjs/toolkit';
import * as searchApi from '../../api/searchApi'

export const searchResult = createAsyncThunk(
	'search/searchResult',
	async ({ data, signal }, { rejectWithValue }) => {
		try {
			// Pass the abort signal to the API call
			const res = await searchApi.searchResults({ data, signal });
			return res.data;
		} catch (error) {
			if (error.name === 'AbortError' || error.name === 'CanceledError') {
			//console.log('Request was aborted');
			return rejectWithValue({ aborted: true });
			}
			console.log('Error fetching search results:', error);
			return rejectWithValue(error.response?.data || 'An error occurred');
		}
	}
);

export const searchResultAppend = createAsyncThunk(
	'search/searchResultAppend',
	async ({ data, signal }, { rejectWithValue }) => {
		try {
			// Pass the abort signal to the API call
			const res = await searchApi.searchResults({ data, signal });
			return res.data;
		} catch (error) {
			if (error.name === 'AbortError' || error.name === 'CanceledError') {
			//console.log('Request was aborted', data);
			return rejectWithValue({ aborted: true });
			}
			console.log('Error fetching search results:', error);
			return rejectWithValue(error.response?.data || 'An error occurred');
		}
	}
);

export const savedContentIds = createAsyncThunk(
	'search/savedContentIds',
	async (filter) => {
		const res = await searchApi.savedContentIds({ data: filter });
		return res.data;
	}
);

export const searchFilters = createAsyncThunk(
	'search/searchFilters',
	async (filter) => {
		const res = await searchApi.searchFilters({ data: filter });
		return res.data;
	}
);

export const fetchPostTypePageHeading = createAsyncThunk(
	'content/fetchPostTypePageHeading',
	async (_, { rejectWithValue }) => {
		try {
			const response = await searchApi.fetchPostTypePageHeading();
			return response.data?.data || {};
		} catch (error) {
			return rejectWithValue(error.response?.data || 'An error occurred');
		}
	}
);

export const autoComplete = createAsyncThunk(
	'search/autocomplete',
	async (filter) => {
		const res = await searchApi.autoComplete({ data: filter });
		return res.data;
	}
);

export const saveContent = createAsyncThunk(
	'content/saveContent',
	async ({ userId, postId }, { rejectWithValue }) => {
		try {
			const response = await searchApi.saveContent({ userId, postId });
			return response.data; // Ensure the response contains the `success` field.
		} catch (error) {
			console.error('Save API Error:', error.toJSON());
			return rejectWithValue(error.response?.data || 'An error occurred');
		}
	}
);

export const getSavedContentIds = createAsyncThunk(
	'content/getSavedContentIds',
	async ({ userId }, { rejectWithValue }) => {
		try {
			const response = await searchApi.getSavedContentIds({ data: { user_id: userId } });
			return response.data; // Ensure response matches the backend structure
		} catch (error) {
			console.error('Saved Content API Error:', error.toJSON());
			return rejectWithValue(error.response?.data || 'An error occurred');
		}
	}
);

export const getRelatedContentData = createAsyncThunk(
	'search/getRelatedContentData',
	async (filter) => {
		const res = await searchApi.getRelatedContent({ data: filter });
		return res.data;
	}
);